/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Callback, IErrorObject} from "../../../../types/platform/universe";
import {AuthLevel} from "../../../../types/aig/universe";

import {Component, OnInit, ViewChild} from "@angular/core";
import {Overlay} from "@angular/cdk/overlay";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MatPaginationIntlService} from "../base/services/i18n-pagenator.service";

import {TranslateService} from "@ngx-translate/core";
import {SessionableComponent} from "../../platform/base/components/sessionable.component";
import {SessionService} from "../../platform/base/services/session.service";

import {MessageDialogComponent} from "../base/components/message-dialog/message-dialog.component";
import {GuestsService} from "./guests.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Observable} from "rxjs";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-guests",
	templateUrl: "./guests.component.html",
	styleUrls: ["./guests.component.css"],
})

export class GuestsComponent extends SessionableComponent implements OnInit {

	@ViewChild('paginator') paginator: MatPaginationIntlService;

	public params: any = {};

	public results: any[] = [];

	public company: string;
	public studio: string;
	public trainer: string;

	public query_type: string = "all";
	public query_username: string = "";
	public query_nickname: string = "";
	public size: number = 20;
	public count: number = 0;

	public breakpoint: number = 4;

	public user: { username: string, user_id: string } = {username: "", user_id: ""};
	public types: any[] = [];

	protected query: object = {};
	protected page: number = 0;

	public report_query: any = {};
	public report_option: any = {};

	// public duplicate: any = {};

	/**
	 *
	 * @param session
	 * @param accountService
	 * @param matDialog
	 * @param overlay
	 * @param router
	 * @param route
	 * @param translate
	 */
	constructor(
		public session: SessionService,
		private accountService: GuestsService,
		private matDialog: MatDialog,
		private snackbar: MatSnackBar,
		protected overlay: Overlay,
		private router: Router,
		protected route: ActivatedRoute,
		public translate: TranslateService
	) {
		super(session);
		this.report_query = JSON.stringify({});
		this.report_option = JSON.stringify({});

		this.translate.onLangChange.subscribe((_event: Event) => {
			this.userTypes();
		});
	}

	/*
	* todo
	*/
	private widthToColumns(width: number): number {
		let result: number;
		result = width / 320;
		return result;
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error: IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	private errorBar(error: IErrorObject): void {
		if (error) {
			this.snackbar.open(error.message, "Close", {
				duration: 4000,
			});
		}
	}

	/**
	 * 完了通知
	 * @param type
	 * @param value
	 * @constructor
	 */
	public Complete(type: string, value: object): void {
		this.complete.emit({type, value});
	}

	/**
	 * @returns none
	 */
	private userTypes(): void {
		this.types = [];
		const auth = this.auth;
		switch (auth) {
			case AuthLevel.system:
			case AuthLevel.manager:
				this.types.push({name: this.translate.instant("管理"), value: "manage"});
				this.types.push({name: this.translate.instant("企業"), value: "company"});
			case AuthLevel.company:
				this.types.push({name: this.translate.instant("スタジオ"), value: "studio"});
			case AuthLevel.studio:
				this.types.push({name: this.translate.instant("トレーナー"), value: "trainer"});
			case AuthLevel.trainer:
				this.types.push({name: this.translate.instant("会員"), value: ""});
				this.types.push({name: this.translate.instant("全て"), value: "all"});
				this.types.push({name: this.translate.instant("未修正"), value: "fix"});
			default:
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.Progress(true);
		this.page = 0;
		this.query = {};
		this.results = [];
		this.breakpoint = this.widthToColumns(window.innerWidth);

		this.getSession((error: IErrorObject, session: any): void => {
			if (!error) {
				this.user.username = session.username;
				this.user.user_id = session.user_id;
				this.route.queryParams.subscribe(params => {
					this.params = params;

					this.company = "";
					this.studio = "";
					this.trainer = "";

					if (this.params.c) {
						this.company = decodeURIComponent(this.params.c);
						if (this.params.s) {
							this.studio = decodeURIComponent(this.params.s);
							if (this.params.t) {
								this.trainer = decodeURIComponent(this.params.t);
							}
						}
					}

					this.userTypes();

					this.draw((error: IErrorObject, accounts: object[]): void => {
						if (!error) {
							this.results = accounts;
						} else {
							this.errorDialog(error);
						}
						this.Progress(false);
					});
				});
			}
		});
	}

	/**
	 * @returns none
	 */
	private buildQuery(): {} {
		let result = {}
		const condition = [];

		if (this.query_username) {
			condition.push({username: {$regex: this.query_username}});
		}

		if (this.query_nickname) {
			condition.push({"content.nickname": {$regex: this.query_nickname}});
		}

		if (this.query_type) {
			if (this.query_type != "all") {
				if (this.query_type == "fix") {
					condition.push({type: ""});
					condition.push({"content.parent": {$exists: false}});
				} else {
					condition.push({type: this.query_type});
				}
			}
		} else {
			condition.push({type: ""});
		}

		if (condition.length) {
			result = {$and: condition};
		}

		return result;
	}

	/**
	 * 再描画
	 * @param callback
	 */
	private draw(callback: Callback<object[]>): void {
		this.Progress(true);
		this.accountService.count(this.query, (error: IErrorObject, result: any): void => {
			if (!error) {
				this.count = result.value;
				// ソート結果をskip/limitでページネーションを行う際、ソートキーのフィールドがインデックスされていないと、ページ間で結果が重複する。
				const option = {sort: {auth: 1}, skip: this.size * this.page, limit: this.size};
				this.accountService.query(this.query, option, (error: IErrorObject, results: any[]): void => {
					if (!error) {
						const accounts: any[] = results.map((result) => {

							result.cols = 1;
							result.rows = 1;
							return result;
						});
						callback(null, accounts);
						this.Complete("", {});
					} else {
						callback(error, null);
						this.Complete("error", error);
					}
					this.Progress(false);
				});
			}
		});
	}

	/*
	* */
	public onRedraw(): void {
		this.Progress(true);
		this.draw((error: IErrorObject, accounts: object[]): void => {
			if (!error) {
				this.results = accounts;
			} else {
				this.errorDialog(error);
			}
			this.Progress(false);
		});
	}

	/**
	 * @returns none
	 */
	public onFind(): void {
		//	this.paginator.firstPage();
		this.page = 0;
		this.query = this.buildQuery();
		this.onRedraw();
	}

	/**
	 * ページ送り
	 * @param event
	 * @constructor
	 */
	public onPage(event: any): void {
		this.page = event.pageIndex;
		this.onRedraw();
	}

	/*
	* */
	public onError(error: any): void {
		this.errorDialog(error.value);
	}

	/**
	 * @returns none
	 */
	public onResize(event: any): void {
		this.breakpoint = this.widthToColumns(event.target.innerWidth);
	}

	/**
	 * @returns none
	 */
	public authToName(auth: number): string {
		let result: string = "その他";
		if (auth <= AuthLevel.system) {
			result = "system";     // system
		} else if (auth <= AuthLevel.manager) {
			result = "マネージャー";     // manager
		} else if (auth <= AuthLevel.company) {
			result = "企業";     // trainer
		} else if (auth <= AuthLevel.studio) {
			result = "スタジオ";     // studio
		} else if (auth <= AuthLevel.trainer) {
			result = "トレーナー";     // trainer
		} else if (auth <= AuthLevel.user) {
			result = "一般";     // user
		}
		return result;
	}

	/**
	 * @returns none
	 */
	public typeToName(type: string): string {
		let result: string = "一般";
		switch (type) {
			case "manage":
				result = "管理";
				break;
			case "company":
				result = "企業";
				break;
			case "studio":
				result = "スタジオ";
				break;
			case "trainer":
				result = "トレーナー";
				break;
		}
		return result;
	}

	/**
	 * account depend.
	 */
	public isSubscribe(account: any): number {
		return account.subscribe;
	}

	/**
	 *
	 */
	public isAccounting(account: any): boolean {
		return account.accounting;
	}

	public belongsPromise(account: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.accountService.belongs(account.user_id, (error: any, _belongs: []) => {
				if (!error) {
					const count = _belongs.filter((account: any) => {
						return (account.type == "studio");
					}).length;
					resolve(count);
				} else {
					reject(new Error('something wrong'))
				}
			});
		});
	}

	public belongsObservable(account: any): Observable<any> {
		return new Observable(subscriber => {
			this.accountService.belongs(account.user_id, (error: any, belongs: []) => {
				if (!error) {
					const count = belongs.filter((account: any) => {
						return (account.type == "studio");
					}).length;
					subscriber.next(count);
					subscriber.complete();
				} else {
					subscriber.error(new Error('something wrong'));
				}
			});
		});
	}

	public test(S: string): Observable<any> {
		return new Observable(subscriber => {
			subscriber.next(S);
		});
	}


	public onFix(account: any): void {
		this.accountService.fix_parent(account.user_id, (error: IErrorObject, result: object[]) => {
			if (!error) {
				this.onRedraw();
			} else {
				this.errorBar(error);
				//		this.errorDialog(error);
			}
		});
	}

	private isValue(value: unknown): boolean {
		return ((value !== null) && (typeof value !== 'undefined'));
	}

	public isFixed(account: any): boolean {
		return this.isValue(account.parent);
	}

	/**
	 *
	 */
	public authIs(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth <= AuthLevel.system);
				break;
			case "manager":
				result = (this.auth <= AuthLevel.manager);
				break;
			case "company":
				result = (this.auth <= AuthLevel.company);
				break;
			case "studio":
				result = (this.auth <= AuthLevel.studio);
				break;
			case "trainer":
				result = (this.auth <= AuthLevel.trainer);
				break;
			case "user":
				result = (this.auth <= AuthLevel.user);
				break;
			case "public":
				result = (this.auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}

	public authEq(level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (this.auth == AuthLevel.system);
				break;
			case "manager":
				result = (this.auth == AuthLevel.manager);
				break;
			case "studio":
				result = (this.auth == AuthLevel.studio);
				break;
			case "user":
				result = (this.auth == AuthLevel.user);
				break;
			case "public":
				result = (this.auth == AuthLevel.public);
				break;
			default:
		}
		return result;
	}

	public accountAuthLE(account: any, level: string): boolean {
		let result: boolean = false;     // public
		switch (level) {
			case "system":
				result = (account.auth <= AuthLevel.system);
				break;
			case "manager":
				result = (account.auth <= AuthLevel.manager);
				break;
			case "company":
				result = (account.auth <= AuthLevel.company);
				break;
			case "studio":
				result = (account.auth <= AuthLevel.studio);
				break;
			case "trainer":
				result = (account.auth <= AuthLevel.trainer);
				break;
			case "user":
				result = (account.auth <= AuthLevel.user);
				break;
			case "public":
				result = (account.auth <= AuthLevel.public);
				break;
			default:
		}
		return result;
	}

	public panelStyle(account: any): any {
		// isSubscribe(account)
		// isAccounting(account)
		let result: any = {background: 'linear-gradient(#3e3d39,#1d1c1b)'};
		const type = account.type;
		switch (type) {
			case "manage":
				result = {background: 'linear-gradient(#393e3c, #1b1d1c)'};
				break;
			case "company":
				result = {background: 'linear-gradient(#3d393e, #1c1b1d)'};
				break
			case "studio":
				result = {background: 'linear-gradient(#3a3e39, #1c1d1b)'};
				break
			case "trainer":
				result = {background: 'linear-gradient(#3e393a, #1d1b1b)'};
				break
		}
		return result;
	}


	/**
	 *
	 */
	public onReport(): void {
		this.Progress(true);
		this.accountService.report({}, {skip: 0, limit: 0, sort: {}}, (error: IErrorObject, result: object[]) => {
			if (!error) {
				let a = result;
			}
			this.Progress(false);
		});
	}

}
